import * as React from 'react';
import type { ArticleListBlockViewModel } from '../ViewModel/ArticleListBlockViewModel.csharp';
import type { ArticleListItemViewModel } from '../ViewModel/ArticleListItemViewModel.csharp';
import type { ArticleListItemProps } from '~/Features/StudyPage/Campus/Components/ArticleList/ArticleList';
import { ArticleList } from '~/Features/StudyPage/Campus/Components/ArticleList/ArticleList';

export const ArticleListBlock: React.FC<ArticleListBlockViewModel> = props => {
    const { id, heading, teaser, articles } = props;

    const mapArticle = (article: ArticleListItemViewModel): ArticleListItemProps => ({
        id: article.id,
        title: article.title,
        description: article.description,
        articleUrl: article.url,
        image: article.image,
    });

    return <ArticleList id={id} heading={heading} teaser={teaser} items={articles.map(mapArticle)} variant="dark" />;
};
